module.exports = __webpack_public_path__ + "static/img/img_iot_al_clw.da466c03.png";